<template>
  <GestionBajas />
</template>
<script>
import GestionBajas from "./components/GestionBajas";
export default {
  name: "Bajas",
  components: { GestionBajas }
};
</script>